module.exports = __webpack_public_path__ + "static/media/fa-brands-400.32bd2b1c.svg";